import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import { message, Modal } from "antd";
import PropTypes from "prop-types";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import {
  getCRCExceptionList,
  getModelNoList,
  getUpdateTypeList,
  getFrameWorkList,
  stubCfgSync,
  cfgFromStub,
} from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import StubParamsConfig from "../../configurationManagement/stub/stubParamsConfig";
import RefreshGrid from "../../../utils/refreshGrid";
@connect((state) => state)
class CrcExceptionList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.crcExceptionList;
    this.init();
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      selectedRowKeys: [],
    };
  }

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: this.internationalization.placeholder1, // '请输入终端编号',
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: this.internationalization.title1, // '终端编号:',
          required: false,
        },
        {
          type: "autoWatch",
          placeholder: this.internationalization.placeholder, // '请选择',
          param: {
            name: "modelNo",
            type: "string",
          },
          labelName: this.internationalization.title2, // '设备型号',
          required: !1,
          sourceApi: getModelNoList,
        },
        {
          type: "inputGroup",
          isArray: true,
          inputGroup: [
            {
              type: "select",
              placeholder: "固件型号:", // this.internationalization.title15 ,//
              width: "95px",
              param: {
                name: "updateType",
                type: "string",
              },
              labelName: "固件信息", // this.internationalization.wz3 ,// '固件信息',
              dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
              required: false,
              onChange: async (value, form) => {
                form.setFieldsValue({
                  frameWork: "",
                  updateType: value,
                });
                fetchHandler(getFrameWorkList, {
                  updateType: value,
                }).then((res) => {
                  const finalData = res.data;
                  finalData.unshift("全部");
                  this.setState(
                    {
                      xhList: finalData.map((v) => {
                        return {
                          text: v,
                          value: v,
                        };
                      }),
                    },
                    () => {
                      this.setState({
                        formConfig: this.initFormConfig(),
                      });
                    },
                  );
                });
              },
            },
            {
              type: "select",
              placeholder: "固件版本", // this.internationalization.title13 ,//'固件版本:',
              width: "95px",
              param: {
                name: "frameWork",
                type: "string",
              },
              options: this.state.xhList,
              required: false,
            },
          ],
        },
        {
          type: "select",
          options: [
            {
              text: this.internationalization.type0, // '全部',
              value: "",
            },
            {
              text: this.internationalization.type1, // '交流电',
              value: "0",
            },
            {
              text: this.internationalization.type2, // '直流电',
              value: "1",
            },
            {
              text: this.internationalization.type3, // '交直流',
              value: "2",
            },
          ],
          placeholder: this.internationalization.placeholder, // '请选择',
          param: {
            name: "stubType",
            type: "string",
          },
          labelName: this.internationalization.title4, // '设备类型:',
          required: false,
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              icon: "search",
              text: this.internationalization.btn1, // '查询'
            },
            {
              btnType: "button",
              text: this.internationalization.btn2, // '批量使用平台配置',
              handler: () => {
                this.handleCfgFromPlatformsBtnClick();
              },
            },
            {
              btnType: "button",
              text: this.internationalization.btn3, // '批量使用设备配置',
              handler: () => {
                this.handleCfgFromStubsBtnClick();
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !0, // 设置为false不触发加载grid
      defaultParams: {},
      context: this,
      tableKey: "crcSearchTable",
    };
    return formConfig;
  };

  init = () => {
    this.tableConfig = {
      tableKey: "crcSearchTable",
      tableColumns: [
        {
          name: this.internationalization.title5, // '设备编号',
          key: "stubId",
          colType: "textCol",
          align: "center",
        },
        {
          name: this.internationalization.title6, // '平台CRC',
          key: "platformConfigCRC",
          colType: "textCol",
          align: "center",
        },
        {
          name: this.internationalization.title7, // '设备CRC',
          key: "stubConfigCRC",
          colType: "textCol",
          align: "center",
          render: (value) => {
            if (value === "") {
              return "--";
            } else {
              return value;
            }
          },
        },
        {
          name: this.internationalization.title8, // '设备类型',
          key: "type",
          colType: "textCol",
          render: (value) => {
            switch (value) {
              case 0:
                return this.internationalization.title9; // '交流电';
              case 1:
                return this.internationalization.title10; // '直流电';
              case 2:
                return this.internationalization.title11; // '交直流';
              default:
                return this.internationalization.result1; // '未知'
            }
          },
        },
        {
          name: this.internationalization.title12, // '设备型号',
          key: "modelNo",
          colType: "textCol",
          align: "center",
        },
        {
          name: this.internationalization.title13, // '固件信息',
          key: "updateType",
          colType: "textCol",
          align: "center",
          width: 250,
          render: (value, row) => {
            if (value === "--") {
              return "--";
            } else {
              return `${value}-${row.frameWork}`;
            }
          },
        },
        {
          name: this.internationalization.action, // '操作',
          key: "action",
          fix: "right",
          width: 250,
          colType: "action",
          actionMap: [
            {
              type: "href",
              actionName: this.internationalization.btn4, // '查看配置',
              handler: (record) => {
                this.setState({
                  seeParamsConfigVisible: true,
                  stubId: record.stubId,
                  stubGroupName: record.stubGroupName,
                  devType: record.type,
                });
              },
            },
            {
              type: "confirm",
              actionName: this.internationalization.btn5, // '使用平台配置',
              handler: (record) => {
                this.setState(
                  {
                    stubId: record.stubId,
                  },
                  () => {
                    this.handleSyncBtnClick();
                  },
                );
              },
            },
            {
              type: "confirm",
              actionName: this.internationalization.btn6, // '使用设备配置',
              handler: (record) => {
                this.setState(
                  {
                    stubId: record.stubId,
                  },
                  () => {
                    this.handleCfgFromStubBtnClick();
                  },
                );
              },
            },
          ],
        },
      ],
      tableParam: {
        pagecount: 10,
      },
      tableInfo: {
        hasRow: !1, // 是否显示checkbox
      },
      dataApi: getCRCExceptionList,
      autoRefresh: !0, // 设置为true 直接加载grid数据
    };
  };

  // 使用平台端配置
  handleSyncBtnClick() {
    stubCfgSync({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg1);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  }

  // 使用设备端配置
  handleCfgFromStubBtnClick() {
    cfgFromStub({
      stubIds: this.state.stubId,
    }).then((res) => {
      if (res && res.data.code === "200") {
        message.success(this.internationalization.msg1);
        this.init();
      } else {
        message.error(res.data.text);
      }
    });
  }

  // 批量使用平台端配置
  handleCfgFromPlatformsBtnClick() {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length === 0) {
      message.error(this.internationalization.msg2);
      return;
    }
    if (selectedRowKeys.length > 100) {
      message.error(this.internationalization.msg3);
      return;
    }
    this.setState(
      {
        stubId: selectedRowKeys.join(","),
      },
      () => {
        this.handleSyncBtnClick();
      },
    );
  }

  // 批量使用设备端配置
  handleCfgFromStubsBtnClick() {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length === 0) {
      message.error(this.internationalization.msg2);
      return;
    }
    if (selectedRowKeys.length > 100) {
      message.error(this.internationalization.msg2);
      return;
    }
    this.setState(
      {
        stubId: selectedRowKeys.join(","),
      },
      () => {
        this.handleCfgFromStubBtnClick();
      },
    );
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  cancelModal(key) {
    this.setState({
      [key]: false,
    });
  }

  openTab = (param, e) => {
    this.props.onAdd(e, param);
    // this.props.handle && this.props.handle()
  };

  onSelectChange = (selectedRowKeys) => {
    this.setState({ selectedRowKeys });
  };

  fetchApi = (param) => {
    const newParam = param;

    if (newParam.updateType === this.internationalization.type0) {
      newParam.updateType = "";
    }

    if (newParam.frameWork === this.internationalization.type0) {
      newParam.frameWork = "";
    }

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      return this.props.modalSubmit(newParam);
    } else {
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "crcSearchTable", newParam);
    }
  };

  render() {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable
            rowSelection={rowSelection}
            config={this.tableConfig}
            rowKey={(record) => record.stubId}
          />
        </div>
        <Modal
          title={this.internationalization.msg5}
          visible={this.state.seeParamsConfigVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => {
            this.modalVisibleAction("seeParamsConfigVisible", false);
          }}>
          <StubParamsConfig
            stubId={this.state.stubId}
            stubGroupName={this.state.stubGroupName}
            devType={this.state.devType}
          />
        </Modal>
      </div>
    );
    return Content;
  }
}

export default injectIntl(CrcExceptionList);
CrcExceptionList.propTypes = {
  // tableKey: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/crcExceptionList/crcExceptionList.js